import { Dialog, TextField } from "@mui/material";
import { useState } from "react";

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DialogContentSelecionarLoja from "../DialogContentSelecionarLoja/DialogContentSelecionarLoja";

export default function SelectLojaComPesquisa({
    value,
    required = false,
    error = false,
    errorMessage = undefined,
    label = 'Loja',
    multiple = false,
    disabled = false,
    extraParams = {},
    onChange
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => setOpenModal(false);

    const inputLabel = (() => {
        if (!value) return "";
        if (Array.isArray(value)) {
            return value.map((item) => item.id).join(", ");
        } else {
            return `${value.id ?? ""}${value.nome ? ` - ${value.nome}` : ""}`;
        }
    })();

    return (
        <>
            <TextField
                disabled={disabled}
                {...{ required, error }}
                label={label}
                variant="outlined"
                fullWidth
                onClick={() => { if (!disabled) setOpenModal(true) }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: {
                        readOnly: true,
                        endAdornment: <KeyboardArrowDownIcon />
                    }
                }}
                value={inputLabel}
                helperText={error ? errorMessage : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelecionarLoja
                        {...{ handleClose, extraParams, multiple }}
                        defaultValue={
                            multiple
                                ? Array.isArray(value) && value.length > 0
                                    ? value
                                    : [defValueLoja]
                                : value
                                    ? value
                                    : defValueLoja
                        }
                        onChange={(value) => {
                            onChange(value as TLoja)
                            handleClose()
                        }}
                    />
                </Dialog>
            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    disabled?: boolean,
    value: TLoja | TLoja[] | null
    onChange: (arg: TLoja | TLoja[] | null) => void
    required?: boolean
    error?: boolean
    errorMessage?: string | undefined
    label?: string
    multiple?: boolean
    extraParams?: { [key: string]: any };
}

export type TLoja = {
    id: number;
    nome: string;
    razao_social?: string;
    cidade?: string;
    uf?: string;
}

const defValueLoja = {
    id: 0,
    nome: '',
}